import styled from 'styled-components';
import { Badge } from '@adobe/react-spectrum';

const NotificationLayout = styled.div`
  margin: 10px 20px;
`;

export type NotificationVariant =
  | 'neutral'
  | 'info'
  | 'positive'
  | 'negative'
  | 'yellow';

interface NotificationProps {
  variant: NotificationVariant;
  children: React.ReactNode;
}

export const Notification = (props: NotificationProps) => {
  const { variant = 'info', children } = props;
  return (
    <NotificationLayout>
      <Badge variant={variant} width="100%">
        {children}
      </Badge>
    </NotificationLayout>
  );
};
